import styled from 'styled-components/macro';

import { Body } from '@cognite/cogs.js';

export const FilterTitle = styled(Body).attrs({ strong: true, level: 2 })`
  padding-bottom: 6px;
  padding-top: 12px;
`;
